import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    show_price_container: {
        display: 'flex',
        flexDirection: "column",
        lineHeight: '16px',
        alignSelf: "center"
    },
    number: {
        fontFamily: 'Alkatra, cursive',
        fontSize: '18px',
        marginLeft: '4px',
        "& > span:last-child":{
            fontSize: '16px',
        }
    },
    currency: {
        fontFamily: 'Alkatra, cursive',
        color: theme.palette.grey[600],
        fontSize: '11px',
        marginLeft: '8px',
        width: 'fit-content'
    },
    positive: {
        color: `${theme.palette.success.light}c9`
    },
    negative: {
        color: theme.palette.error.light
    },
    value_before:{
        color: theme.palette.grey[400],
        fontSize: '11px',
        marginLeft: '8px'
    }
}));

export {useStyles}